import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBag2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShoppingBag2"><Path d="M15.5 7.5V6C15.5 4.067 13.933 2.5 12 2.5C10.067 2.5 8.5 4.067 8.5 6V7.5M6 7.5H18L20 21.5H4L6 7.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconShoppingBag2;
